import React from 'react';
import styled from 'styled-components';
import PageHeroImage from '../../assets/general/home-hero-bg.jpeg';

const MainContainer = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(${PageHeroImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const MainContent = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin: 0 auto;
`;

const TitleContainer = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.headline};
  text-transform: capitalize;
  text-align: center;
  margin: 0;
  letter-spacing: 2px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
`;

const IntelliCubixColored = styled.img`
  width: 350px;
  height: 59px;
`

const PageHeroSection = ({ pageTitle }) => {
  return <MainContainer>
    <Overlay>
      <MainContent>
        <TitleContainer>{pageTitle}</TitleContainer>
      </MainContent>
    </Overlay>
  </MainContainer>;
};

export default PageHeroSection;